import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/Auth";

export default function Onboarding() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [cats, setCats] = useState<any[]>([]);
  const [niches, setNiches] = useState<string[]>([]);
  const [username, setUsername] = useState(user?.username || "");
  const [birthdate, setBirthdate] = useState(user?.birthdate || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);
  const toggle = (s: string) => setNiches((n) => (n.includes(s) ? n.filter((x) => x !== s) : n.length < 5 ? [...n, s] : n));
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/onboarding", { niches, username: username || undefined, birthdate: birthdate || undefined });
      setUser(data);
      nav("/");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-[100dvh] px-6 sm:px-12 py-12 max-w-3xl mx-auto rise" data-testid="onboarding-page">
      <div className="label text-primary mb-3">Benvenuto su UNSEEN</div>
      <h1 className="font-display text-3xl sm:text-5xl font-black tracking-tighter mb-4">Qual è la tua scena?</h1>
      <p className="text-ink/70 mb-10">Scegli da 1 a 5 nicchie. La prima diventa la tua nicchia principale sul profilo.</p>
      {(!user?.username || !user?.birthdate) && (
        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          {!user?.username && <input className="field" placeholder="@username" value={username} onChange={(e) => setUsername(e.target.value.toLowerCase().replace(/[^a-z0-9_.]/g, ""))} data-testid="onboarding-username-input" />}
          {!user?.birthdate && <label><span className="label text-ink/62">Data di nascita · minimo 16 anni</span><input type="date" className="field mt-2 [color-scheme:light]" value={birthdate} onChange={(e) => setBirthdate(e.target.value)} data-testid="onboarding-birthdate-input" /></label>}
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-10">
        {cats.map((c) => {
          const i = niches.indexOf(c.slug);
          return (
            <button key={c.slug} onClick={() => toggle(c.slug)} data-testid={`niche-${c.slug}`}
              className={`relative text-left p-5 h-28 surface ${i >= 0 ? "bg-white/80 shadow-[inset_0_0_0_2px_hsl(var(--primary)/.55)]" : "hover:bg-white/60"}`}>
              <span className="font-display font-bold text-lg leading-tight">{c.name}</span>
              {i >= 0 && <span className="absolute top-3 right-3 font-mono text-sm">{i + 1}</span>}
            </button>
          );
        })}
      </div>
      <button className="btn btn-primary w-full sm:w-auto px-10" disabled={!niches.length || busy} onClick={submit} data-testid="onboarding-submit-btn">Entra in UNSEEN</button>
    </div>
  );
}
